import { render } from "./goods-tabs.vue?vue&type=template&id=8f0ecbae&scoped=true"
import script from "./goods-tabs.vue?vue&type=script&lang=js"
export * from "./goods-tabs.vue?vue&type=script&lang=js"

import "./goods-tabs.vue?vue&type=style&index=0&id=8f0ecbae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@5.6.2__webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0ecbae"]])

export default __exports__